'use strict';

module.exports = require('./ckeditor');